import auth from './modules/auth';

/* eslint-disable */

const initialState = {

};

const getters = {

};

const actions = {

};

const mutations = {

};


export default {
  namespaced: true,
  modules: {
    auth,
  },
  state: initialState,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/modules/Auth/store.js